import React from "react";
import { Dialog, DialogContent } from "../../components/ui/dialog";

const Modal = ({ isOpen, onClose, children, className = "" }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent
        className={`max-w-3xl ${className}`}
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
